import React from "react";
import "./style.scss";
import HTMLReactParser from "html-react-parser";
import howToParticipate from "./img/how-to-participate.png";

import participate1 from "./img/participate-1.png";
import participate2 from "./img/participate-2.png";
import participate3 from "./img/participate-3.png";
import participate4 from "./img/participate-4.png";
import participate5 from "./img/participate-5.png";
import { useTranslation } from 'react-i18next';
export default function FindAMentor(props) {
  const { t } = useTranslation();
  const keyData = props.data;
  return (
    <div>
      <div className="find-mneotr-desktop">
        <section id="unique">
          <div className="w-100 pt-50 pb-50 position-relative">
            <div className="container">
              <div className="row">
                <div className="sec-title text-center w-100 position-relative">
                  <h2 className="mb-0 homepageFirstHeader">
                  {t('How_to_Participate')}
                    {/* How to Participate */}
                    </h2>
                </div>
              </div>
            </div>
            <div className="container-fluid" id="line">
              <div className="row">
                <div
                  className="col-md-12 col-sm-6 col-lg-12"
                  style={{ padding: "0px" }}
                >
                  <img src={howToParticipate} style={{ width: "100%" }} />
                </div>
              </div>
            </div>
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-1 col-sm-6 col-lg-1">
                </div>
                {keyData.map((data, index) => {
                  return (
                    <div className="col-md-2 col-sm-6 col-lg-2" key={index}>
                      <div className="unique-sec homepageFirstDescription">
                        <a className="unique-heading participateheadingdata" style={{ fontSize: "20px"}}>
                          {data.Heading}
                        </a>
                        {HTMLReactParser(data.Text)}
                      </div>
                    </div>
                  );
                })}
                <div className="col-md-1 col-sm-6 col-lg-1">
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      {/*Mobile start*/}

      <div className="find-mentor-moiobile">
        <section id="unique-mobile">
          <div className="w-100 pt-50 pb-50 position-relative">
            <div className="container">
              <div className="row">
                <div className="sec-title text-center w-100 position-relative">
                  <h2 className="mb-0">How to Participate</h2>
                </div>
              </div>
            </div>
            <div className="container">
              <div className="row">
                <div className="col-md-1 col-sm-6 col-lg-1"></div>
                <div className="col-md-2 col-sm-6 col-lg-2">
                  <div className="unique-sec">
                    <img src={participate1} />
                    <br />
                    <a className="unique-heading">{keyData[0].Heading}</a>
                    {HTMLReactParser(keyData[0].Text)}
                  </div>
                </div>
                <div className="col-md-2 col-sm-6 col-lg-2">
                  <div className="unique-sec">
                    <img src={participate2} />
                    <br />
                    <a className="unique-heading">{keyData[1].Heading}</a>
                    {HTMLReactParser(keyData[1].Text)}
                  </div>
                </div>
                <div className="col-md-2 col-sm-6 col-lg-2">
                  <div className="unique-sec">
                    <img src={participate3} /> <br />
                    <a className="unique-heading">{keyData[2].Heading}</a>
                    {HTMLReactParser(keyData[2].Text)}
                  </div>
                </div>
                <div className="col-md-2 col-sm-6 col-lg-2">
                  <div className="unique-sec">
                    <img src={participate4} />
                    <br />
                    <a className="unique-heading">{keyData[3].Heading}</a>
                    {HTMLReactParser(keyData[3].Text)}
                  </div>
                </div>
                <div className="col-md-2 col-sm-6 col-lg-2">
                  <div className="unique-sec">
                    <img src={participate5} />
                    <br />
                    <a className="unique-heading">{keyData[4].Heading}</a>
                    {HTMLReactParser(keyData[4].Text)}
                  </div>
                </div>
                <div className="col-md-1 col-sm-6 col-lg-1"></div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
